import { WMSUploadDocument } from 'components/waste-management/interfaces'
import { toDocumentsUploadPayload } from 'components/waste-management/serializers'
import { useMutation } from 'react-query'
import { makeCorePostRequest } from 'utils/api'

const useUpload = ({ reportId, reportType, onSuccess, onError }) => {
  const addReportDocuments = async (values: WMSUploadDocument[]) => {
    await makeCorePostRequest(
      '/waste-management-system/document/upload',
      toDocumentsUploadPayload(values),
      {
        params: {
          reportId,
          reportType
        }
      }
    )
  }

  const { mutate: mutateReportDocuments } = useMutation(addReportDocuments, {
    onSuccess: res => {
      onSuccess()
    },
    onError: error =>
      onError(error)
  })

  const saveDocuments = async (documents: WMSUploadDocument[]) => {
    mutateReportDocuments(documents)
  }

  return { saveDocuments }
}

export default useUpload
